import { useAppDispatch, useAppSelector } from '@store/hooks'
import { getSeatingAreas, selectSeatingAreas } from '@store/SeatingAreaReducer'
import { initialQuery, TableParams } from '@supplement-bacon/sb-table-filters'
import { Button, Flex, Spin, Typography } from 'antd'
import { useEffect } from 'react'
import SeatingArea from '../../../seatingArea/SeatingArea'
import { StepProps } from '../../types'
import { ContentWrapper } from './ContentWrapper'
import { VenueIntegrationDisplaySettings } from './VenueIntegrationDisplaySettings'

const { Title, Text } = Typography

export const AreaBookingVisibilities = ({
  venue,
  product,
  onPrev,
  onNext,
}: StepProps) => {
  const dispatch = useAppDispatch()
  const seatingAreas = useAppSelector(selectSeatingAreas())
  const { isLoading } = useAppSelector((state) => state.seatingArea)

  useEffect(() => {
    // Make sure to always load all associations
    const query: TableParams = {
      ...initialQuery,
      pagination: { ...initialQuery.pagination, pageSize: 100 },
      filters: {
        venues: [venue.id],
      },
      with: ['venueSeatingAreas'],
    }
    dispatch(getSeatingAreas(query))
  }, [venue])

  return (
    <>
      <ContentWrapper>
        <Flex vertical gap={5}>
          <Title className="m-0" level={5}>
            Select wich areas are bookable from this venue
          </Title>
          <Text>
            You can choose which Areas you want to enable for reservations from{' '}
            {venue.name} application page or WhatsApp number.
          </Text>
        </Flex>
        <Flex vertical gap={20}>
          {isLoading && <Spin />}
          {seatingAreas.map((seatingArea) => (
            <SeatingArea.VisibilityCardForm
              key={seatingArea.id}
              id={seatingArea.id}
            />
          ))}
        </Flex>
        <VenueIntegrationDisplaySettings
          venueSlug={venue.slug}
          product={product}
        />
      </ContentWrapper>
      <Flex justify="flex-end" gap={8}>
        <Button onClick={onPrev}>Previous</Button>
        <Button type="primary" loading={false} onClick={onNext}>
          Next
        </Button>
      </Flex>
    </>
  )
}
